import Spinner from "react-bootstrap/Spinner";

const LoadingSkeleton = () => {
  return (
    <div
      className="skeleton"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "120px",
      }}
    >
      <Spinner animation="border" role="status" variant="primary" />
    </div>
  );
};
export default LoadingSkeleton;
